/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListEventTypesGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListEventTypesRequest = {};

export type ListEventTypesResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.EventType>;
};

/** @internal */
export const ListEventTypesGlobals$inboundSchema: z.ZodType<
  ListEventTypesGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListEventTypesGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListEventTypesGlobals$outboundSchema: z.ZodType<
  ListEventTypesGlobals$Outbound,
  z.ZodTypeDef,
  ListEventTypesGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listEventTypesGlobalsToJSON(
  listEventTypesGlobals: ListEventTypesGlobals,
): string {
  return JSON.stringify(
    ListEventTypesGlobals$outboundSchema.parse(listEventTypesGlobals),
  );
}
export function listEventTypesGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListEventTypesGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEventTypesGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEventTypesGlobals' from JSON`,
  );
}

/** @internal */
export const ListEventTypesRequest$inboundSchema: z.ZodType<
  ListEventTypesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type ListEventTypesRequest$Outbound = {};

/** @internal */
export const ListEventTypesRequest$outboundSchema: z.ZodType<
  ListEventTypesRequest$Outbound,
  z.ZodTypeDef,
  ListEventTypesRequest
> = z.object({});

export function listEventTypesRequestToJSON(
  listEventTypesRequest: ListEventTypesRequest,
): string {
  return JSON.stringify(
    ListEventTypesRequest$outboundSchema.parse(listEventTypesRequest),
  );
}
export function listEventTypesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEventTypesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEventTypesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEventTypesRequest' from JSON`,
  );
}

/** @internal */
export const ListEventTypesResponse$inboundSchema: z.ZodType<
  ListEventTypesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.EventType$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListEventTypesResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.EventType$Outbound>;
};

/** @internal */
export const ListEventTypesResponse$outboundSchema: z.ZodType<
  ListEventTypesResponse$Outbound,
  z.ZodTypeDef,
  ListEventTypesResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.EventType$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listEventTypesResponseToJSON(
  listEventTypesResponse: ListEventTypesResponse,
): string {
  return JSON.stringify(
    ListEventTypesResponse$outboundSchema.parse(listEventTypesResponse),
  );
}
export function listEventTypesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListEventTypesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEventTypesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEventTypesResponse' from JSON`,
  );
}
